import React, { useState } from "react";
import { useI18n } from "../i18n";
import LegalModal from "./LegalModal";

/**
 * ConsentCheckboxes — KVKK (required) and ETK (optional) consents.
 * Props:
 *   - kvkk: boolean
 *   - etk: boolean
 *   - onChange: ({ kvkk, etk }) => void
 *   - testIdPrefix: string (e.g. "register" or "lead")
 */
export default function ConsentCheckboxes({ kvkk, etk, onChange, testIdPrefix = "consent" }) {
  const { lang } = useI18n();
  const [openModal, setOpenModal] = useState(null); // "kvkk" | "etk" | null

  const set = (patch) => onChange({ kvkk, etk, ...patch });

  const linkCls =
    "cursor-pointer font-medium text-[#14512f] underline decoration-[#14512f]/40 underline-offset-2 hover:decoration-[#14512f]";

  const openLink = (kind) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenModal(kind);
  };

  return (
    <>
      <div className="space-y-2 text-[12.5px] leading-relaxed text-[#3b423a]" data-testid={`${testIdPrefix}-consents`}>
        <label className="flex items-start gap-2.5">
          <input
            type="checkbox"
            checked={kvkk}
            onChange={(e) => set({ kvkk: e.target.checked })}
            data-testid={`${testIdPrefix}-kvkk`}
            className="mt-0.5 h-4 w-4 flex-shrink-0 accent-[#14512f]"
          />
          <span>
            {lang === "en" ? (
              <>
                I have read the KVKK{" "}
                <a href="#kvkk" onClick={openLink("kvkk")} className={linkCls} data-testid={`${testIdPrefix}-kvkk-link`}>
                  privacy notice
                </a>{" "}
                and consent to the processing of my contact information.{" "}
                <span className="text-red-600">*</span>
              </>
            ) : (
              <>
                KVKK kapsamında{" "}
                <a href="#kvkk" onClick={openLink("kvkk")} className={linkCls} data-testid={`${testIdPrefix}-kvkk-link`}>
                  aydınlatma metnini
                </a>{" "}
                okudum, iletişim bilgilerimin işlenmesini kabul ediyorum.{" "}
                <span className="text-red-600">*</span>
              </>
            )}
          </span>
        </label>

        <label className="flex items-start gap-2.5">
          <input
            type="checkbox"
            checked={etk}
            onChange={(e) => set({ etk: e.target.checked })}
            data-testid={`${testIdPrefix}-etk`}
            className="mt-0.5 h-4 w-4 flex-shrink-0 accent-[#14512f]"
          />
          <span>
            {lang === "en" ? (
              <>
                I have read the ETK{" "}
                <a href="#etk" onClick={openLink("etk")} className={linkCls} data-testid={`${testIdPrefix}-etk-link`}>
                  privacy notice
                </a>{" "}
                and would like to receive news and promotions.
              </>
            ) : (
              <>
                ETK kapsamında{" "}
                <a href="#etk" onClick={openLink("etk")} className={linkCls} data-testid={`${testIdPrefix}-etk-link`}>
                  aydınlatma metnini
                </a>{" "}
                okudum, reklam ve duyurulardan haberdar olmak istiyorum.
              </>
            )}
          </span>
        </label>
      </div>

      <LegalModal open={openModal !== null} kind={openModal} onClose={() => setOpenModal(null)} />
    </>
  );
}
